import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    logout: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label that logs the user out from the account avatar menu */
            logout: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "LogoutNavItem.logout?c=29d98xmzcj3zm", defaultMessage: "Log out" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
